import { DEFAULT_TEMPLATE_TWO_PAGES } from '@src/@core/components/SharedComponents/Pdf/QuotationTemplates/TemplateTwo/pagesMerge';
import { TEMPLATE_THREE_COVER_DEFAULTS } from '@src/@core/components/SharedComponents/Pdf/QuotationTemplates/TemplateThree/coverConfig';

// ─── Shared defaults ────────────────────────────────────────────────────────

const defaultTheme = { color: '#235975' };

const defaultLogo = {
    bgColor: 'white',
    width: 120,
    height: 62,
    borderRadius: 4,
    show: true,
    type: 'image',
    text: '',
    textColor: '#235975',
};

const templateTwoLogo = {
    ...defaultLogo,
    cover: { width: 120, textWidth: 64, height: 62, borderRadius: 4 },
    inner: { width: 80, textWidth: 80, height: 40, borderRadius: 4 },
};

const createFooterData = () => ({
    show: true,
    data: [{ address_label: '', email: '', mobile: '', address: '' }],
});

// ─── Per-template configs ────────────────────────────────────────────────────

/** template_1 → QuotationTemplateOne (themed single-page) — theme + logo + footer */
export const template1Config = {
    configs: {
        theme: defaultTheme,
        logo: defaultLogo,
        sections: {
            quotationDetails: {
                showDepartment: true,
                showSalesRef: true,
                showReference: true,
            },
        },
    },
    footer_data: createFooterData(),
};

/** template_2 → QuotationTemplateTwo (multi-page offer) — theme + logo + pages */
export const template2Config = {
    configs: {
        theme: defaultTheme,
        logo: templateTwoLogo,
        pages: DEFAULT_TEMPLATE_TWO_PAGES,
    },
    footer_data: createFooterData(),
};

/**
 * vendor_order_template_1 → reuses QuotationTemplateOne for purchase orders.
 * Deliberately leaner than `template1Config`: only the keys the vendor editor
 * exposes, so the template's own prop defaults still drive everything else.
 */
export const vendorOrderTemplate1Config = {
    configs: {
        theme: defaultTheme,
        logo: { show: true },
    },
    footer_data: { show: true, data: [] },
};

// ─── Combined export ─────────────────────────────────────────────────────────

export const template3Config = {
    configs: {
        theme: { color: '#102c4c', accentColor: '#df2040' },
        logo: { ...defaultLogo, width: 100, height: 46, textColor: '#102c4c' },
        cover: { ...TEMPLATE_THREE_COVER_DEFAULTS },
    },
    footer_data: createFooterData(),
};

const pdfTemplateConfig = {
    template_1: template1Config,
    template_2: template2Config,
    template_3: template3Config,
    vendor_order_template_1: vendorOrderTemplate1Config,
};

export default pdfTemplateConfig;
